// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var CallRecordingSetting;
(function (CallRecordingSetting) {
    CallRecordingSetting["UNSPECIFIED"] = "UNSPECIFIED";
    CallRecordingSetting["BOTH"] = "BOTH";
    CallRecordingSetting["INBOUND"] = "INBOUND";
    CallRecordingSetting["OUTBOUND"] = "OUTBOUND";
    CallRecordingSetting["NONE"] = "NONE";
})(CallRecordingSetting || (CallRecordingSetting = {}));
export var CallRecordingSetting_index;
(function (CallRecordingSetting_index) {
    CallRecordingSetting_index[CallRecordingSetting_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    CallRecordingSetting_index[CallRecordingSetting_index["BOTH"] = 1] = "BOTH";
    CallRecordingSetting_index[CallRecordingSetting_index["INBOUND"] = 2] = "INBOUND";
    CallRecordingSetting_index[CallRecordingSetting_index["OUTBOUND"] = 3] = "OUTBOUND";
    CallRecordingSetting_index[CallRecordingSetting_index["NONE"] = 4] = "NONE";
})(CallRecordingSetting_index || (CallRecordingSetting_index = {}));
// This service applies call-related changes at the phone-system (aka tenant level). It does not manage call objects.
export const PhoneCallConfigAPI = {
    // NWX endpoint, location-id is not used
    // In NWX, tenant external key authorization is required for these
    // endpoints. This means we'll use phone-auth-api's AuthorizeTenant, which
    // checks the tenant's external key location (EKL) ACLs.
    // To handle the new Phone Admin role that will be introduced, you can use
    // the PHONE_FULL_ACCESS ACL, or a more specific ACL if desired.
    GetCallRecording(fn, req) {
        try {
            fm.validateUrlParam(req["tenantId"], "tenantId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/call-config/v2/${req["tenantId"]}/call-recording?${fm.renderURLSearchParams(req, ["tenantId"])}`, { method: "GET" });
    },
    // NWX endpoint, location-id is not used
    // In NWX, tenant external key authorization is required for these
    // endpoints. This means we'll use phone-auth-api's AuthorizeTenant, which
    // checks the tenant's external key location (EKL) ACLs.
    // To handle the new Phone Admin role that will be introduced, you can use
    // the PHONE_FULL_ACCESS ACL, or a more specific ACL if desired.
    UpdateCallRecording(fn, req) {
        try {
            fm.validateUrlParam(req["tenantId"], "tenantId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/call-config/v2/${req["tenantId"]}/call-recording/update`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
